function getSlick($slider) {
    var slider;

    if (!$slider || !$slider.length) {
        return null;
    }

    if ($.fn && typeof $.fn.slick === 'function') {
        try {
            return $slider.slick('getSlick');
        } catch (e) {
            // Fall back to the instance stored by Slick on the DOM element.
        }
    }

    slider = $slider[0];

    return slider && slider.slick ? slider.slick : null;
}

function runSlick($slider, method) {
    var args = Array.prototype.slice.call(arguments, 2);
    var slick;

    if (!$slider || !$slider.length) {
        return false;
    }

    if ($.fn && typeof $.fn.slick === 'function') {
        try {
            $slider.slick.apply($slider, [method].concat(args));
            return true;
        } catch (e) {
            // Fall back to the instance stored by Slick on the DOM element.
        }
    }

    slick = getSlick($slider);
    if (slick && typeof slick[method] === 'function') {
        slick[method].apply(slick, args);
        return true;
    }

    return false;
}

(function ($) {
    function getSliderCurrentSlide($slider) {
        var slick = getSlick($slider);

        return slick ? slick.currentSlide || 0 : 0;
    }

    function updateCompletedDots($slider, activeIndex) {
        var currentSlide =
            typeof activeIndex === 'number'
                ? activeIndex
                : getSliderCurrentSlide($slider);

        $slider.find('.slick-dots li').each(function (index) {
            $(this).toggleClass('completed', index <= currentSlide);
        });
    }

    function bindSliderEvents($slider) {
        var slick = getSlick($slider);

        if ($slider.data('specialDotsBound')) {
            return;
        }

        if (!slick) {
            return;
        }

        $slider.data('specialDotsBound', true);
        $slider.data(
            'desktopSlidesToShow',
            slick.originalSettings.slidesToShow ||
            slick.options.slidesToShow
        );

        $slider.on('beforeChange.specialDots', function (
            event,
            slick,
            currentSlide,
            nextSlide
        ) {
            updateCompletedDots($(this), nextSlide);
        });

        $slider.on('afterChange.specialDots', function (event, slick, currentSlide) {
            updateCompletedDots($(this), currentSlide);
        });

        $slider.on(
            'reInit.specialDots breakpoint.specialDots setPosition.specialDots',
            function () {
                var slider = this;
                setTimeout(function () {
                    setupSliderControls(slider);
                }, 0);
            }
        );
    }

    function setupSliderControls(slider) {
        var $slider = $(slider);

        if (!$slider.hasClass('tile-content-slider')) {
            $slider = $slider.find('.tile-content-slider.slick-initialized').first();
        }

        if (!$slider.length || !$slider.hasClass('slick-initialized')) {
            return;
        }

        var $dots = $slider.children('.slick-dots').first();
        var $prevArrow = $slider.children('.slick-prev').first();
        var $nextArrow = $slider.children('.slick-next').first();

        if (!$dots.length) {
            $dots = $slider.find('.slick-dots').first();
        }

        if (!$prevArrow.length) {
            $prevArrow = $slider.find('.slick-prev').first();
        }

        if (!$nextArrow.length) {
            $nextArrow = $slider.find('.slick-next').first();
        }

        if (!$dots.length || !$prevArrow.length || !$nextArrow.length) {
            return;
        }

        var $dotsContainer = $slider.children('.slick-dots-container').first();
        if (!$dotsContainer.length) {
            $dotsContainer = $('<div class="slick-dots-container"></div>');
            $dotsContainer.insertBefore($dots);
        }

        $dotsContainer.append($dots);
        $dots.attr('aria-hidden', true);

        var $arrowWrapper = $dotsContainer.children('.slick-arrow-wrapper').first();
        if (!$arrowWrapper.length) {
            $arrowWrapper = $('<div class="slick-arrow-wrapper"></div>');
            $dotsContainer.append($arrowWrapper);
        }

        $arrowWrapper.append($prevArrow, $nextArrow);

        bindSliderEvents($slider);
        updateCompletedDots($slider);
    }

    function setupAllSliderControls() {
        $('.tileContent.slick-initialized.tile-content-slider').each(function () {
            setupSliderControls(this);
        });
    }

    function forceResponsiveSlides($slider) {
        var slick = getSlick($slider);
        var desktopSlidesToShow;
        var slidesToShow;

        if (!slick) {
            return;
        }

        desktopSlidesToShow =
            $slider.data('desktopSlidesToShow') ||
            slick.originalSettings.slidesToShow ||
            slick.options.slidesToShow;
        slidesToShow = window.matchMedia('(max-width: 991px)').matches
            ? 1
            : desktopSlidesToShow;

        if (slick.options.slidesToShow === slidesToShow) {
            return;
        }

        runSlick($slider, 'slickSetOption', 'slidesToShow', slidesToShow, false);
        runSlick($slider, 'slickSetOption', 'slidesToScroll', 1, true);
    }

    var checkSlickInitialized = setInterval(function () {
        if ($('.tileContent.slick-initialized.tile-content-slider').length) {
            clearInterval(checkSlickInitialized);
            setupAllSliderControls();
        }
    }, 100);

    $(document).on('patSliderInit.specialDots', function (e) {
        var detail = e.originalEvent && e.originalEvent.detail;
        setTimeout(function () {
            if (detail) {
                setupSliderControls(detail);
            }
            setupAllSliderControls();
        }, 0);
    });

    var resizeSliderTimeout = null;
    $(window).on('resize orientationchange', function () {
        clearTimeout(resizeSliderTimeout);
        resizeSliderTimeout = setTimeout(function () {
            $(
                '.slider-notizie .tileContent.slick-initialized.tile-content-slider'
            ).each(function () {
                var $slider = $(this);
                forceResponsiveSlides($slider);
                runSlick($slider, 'resize');
                runSlick($slider, 'setPosition');
                setupSliderControls(this);
            });
        }, 150);
    });
})(jQuery);

(function ($) {
    function updateAreeTematicheSliderDots($slider, activeIndex) {
        var currentSlide = typeof activeIndex === 'number' ? activeIndex : 0;

        if (typeof activeIndex !== 'number') {
            var slick = getSlick($slider);
            currentSlide = slick ? slick.currentSlide || 0 : 0;
        }

        $slider.find('.slick-dots li').each(function (index) {
            $(this).toggleClass('completed', index <= currentSlide);
        });
    }

    function setupAreeTematicheSliderControls(slider) {
        var $slider = $(slider);
        var $controls = $slider.children('.aree-tematiche-slider-controls').first();
        var $dots = $slider.children('.slick-dots').first();
        var $prevArrow = $slider.children('.slick-prev').first();
        var $nextArrow = $slider.children('.slick-next').first();

        if (!$slider.hasClass('slick-initialized')) {
            return;
        }

        if ($controls.length) {
            if (!$dots.length) {
                $dots = $controls.children('.slick-dots').first();
            }

            if (!$prevArrow.length) {
                $prevArrow = $controls.children('.slick-prev').first();
            }

            if (!$nextArrow.length) {
                $nextArrow = $controls.children('.slick-next').first();
            }
        }

        if (!$dots.length || !$prevArrow.length || !$nextArrow.length) {
            return;
        }

        if (!$controls.length) {
            $controls = $('<div class="aree-tematiche-slider-controls"></div>');
            $slider.append($controls);
        }

        $controls.append($prevArrow, $dots, $nextArrow);
        updateAreeTematicheSliderDots($slider);

        if ($slider.data('areeTematicheDotsBound')) {
            return;
        }

        $slider.data('areeTematicheDotsBound', true);

        $slider.on('beforeChange.areeTematicheDots', function (
            event,
            slick,
            currentSlide,
            nextSlide
        ) {
            updateAreeTematicheSliderDots($(this), nextSlide);
        });

        $slider.on('afterChange.areeTematicheDots', function (
            event,
            slick,
            currentSlide
        ) {
            updateAreeTematicheSliderDots($(this), currentSlide);
        });

        $slider.on(
            'reInit.areeTematicheDots breakpoint.areeTematicheDots setPosition.areeTematicheDots',
            function () {
                var currentSlider = this;

                setTimeout(function () {
                    setupAreeTematicheSliderControls(currentSlider);
                }, 0);
            }
        );
    }

    function setupAllAreeTematicheSliderControls() {
        $('.aree-tematiche-slider .tileContent.slick-initialized').each(function () {
            setupAreeTematicheSliderControls(this);
        });
    }

    var checkAreeTematicheSliderInitialized = setInterval(function () {
        if ($('.aree-tematiche-slider .tileContent.slick-initialized').length) {
            clearInterval(checkAreeTematicheSliderInitialized);
            setupAllAreeTematicheSliderControls();
        }
    }, 100);

    $(document).on('patSliderInit.areeTematicheDots', function () {
        setTimeout(setupAllAreeTematicheSliderControls, 0);
    });
})(jQuery);

(function ($) {
    $(document).on(
        'click',
        '.slider-homepage-prev, .slider-homepage-next',
        function (e) {
            var $button = $(this);
            var $slider = $button
                .closest('.slider-homepage-wrapper')
                .find('.slider-homepage-list.slick-initialized');

            e.preventDefault();

            if (!$slider.length) {
                return;
            }

            runSlick(
                $slider,
                $button.hasClass('slider-homepage-prev') ? 'slickPrev' : 'slickNext'
            );
        }
    );

    $(document).on('click', '.slider-homepage-pause', function (e) {
        var $button = $(this);
        var $slider = $button
            .closest('.slider-homepage-wrapper')
            .find('.slider-homepage-list.slick-initialized');
        var isPaused = $button.hasClass('is-paused');

        e.preventDefault();

        if (!$slider.length) {
            return;
        }

        if (isPaused) {
            if (!runSlick($slider, 'slickPlay')) {
                return;
            }

            $button
                .removeClass('is-paused')
                .attr('aria-label', $button.data('pause-label'));
        } else {
            if (!runSlick($slider, 'slickPause')) {
                return;
            }

            $button
                .addClass('is-paused')
                .attr('aria-label', $button.data('play-label'));
        }
    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        var sliders = document.querySelectorAll('.tileContent.slick-initialized');

        if (sliders.length > 1) {
            // Rimuovi tutti tranne il primo
            for (var i = 1; i < sliders.length; i++) {
                if ($(sliders[i]).hasClass('slick-initialized')) {
                    runSlick($(sliders[i]), 'unslick');
                }
                sliders[i].remove();
            }
        }
    }, 500); // aspetta che si carichi tutto
});
